export const REPORT_STAT_FLAGS_TYPE_HISTORIC_ONLY = 0x04 // Basic historic only reporting (Akixi 500).
export const REPORT_STAT_FLAGS_TYPE_BLF = 0x20 // BLF views only with limited historic call list reporting (Akixi 750).
export const REPORT_STAT_FLAGS_TYPE_STD = 0x0100 // Standard reporting (Akixi 1000).
export const REPORT_STAT_FLAGS_TYPE_ACD = 0x0800 // ACD reporting (Akixi 2000).
export const REPORT_STAT_FLAGS_TYPE_NONE = 0
